// 文章203数据信息
export default {
  id: '203',
  title: '问心岛心理疗愈简介',
  createTime: '2025年04月13日',
  content: `![img](https://cdn.keihong.tech/img/20250422163233352.png)

![img](https://cdn.keihong.tech/img/20250422163233413.png)

![img](https://cdn.keihong.tech/img/20250422163233560.png)

![img](https://cdn.keihong.tech/img/20250422163233511.png)

![img](https://cdn.keihong.tech/img/20250422163233764.png)

![img](https://cdn.keihong.tech/img/20250422163233462.png)

![img](https://cdn.keihong.tech/img/20250422163234349.png)

![img](https://cdn.keihong.tech/img/20250422163234281.png)

![img](https://cdn.keihong.tech/img/20250422163234382.png)

![img](https://cdn.keihong.tech/img/20250422163234156.png)

![img](https://cdn.keihong.tech/img/20250422163234665.png)

![img](https://cdn.keihong.tech/img/20250422163234811.png)

![img](https://cdn.keihong.tech/img/20250422163235179.png)

![img](https://cdn.keihong.tech/img/20250422163235042.png)

![img](https://cdn.keihong.tech/img/20250422163235087.png)`
}
